import {
  addWeeks,
  format,
  getISOWeek,
  isAfter,
  min,
  parseISO,
  startOfISOWeek,
} from 'date-fns'

export interface WeekHours {
  weekStart: string
  totalHours: number
  driveHours: number
  workHours: number
  availableHours: number
  days: number
}

export interface YearWeek extends WeekHours {
  isoWeek: number
}

const EMPTY = {
  totalHours: 0,
  driveHours: 0,
  workHours: 0,
  availableHours: 0,
  days: 0,
}

/**
 * Every ISO week that touches the year, up to the current week, with the ones
 * without work as zero rows. The first and last week can reach into the
 * neighbouring years; only the days inside the year are counted in them.
 */
export const yearWeeks = (
  year: number,
  weeks: WeekHours[],
  today = new Date()
): YearWeek[] => {
  const byStart = new Map(weeks.map(week => [week.weekStart, week]))
  const last = min([new Date(year, 11, 31), today])
  const result: YearWeek[] = []

  for (
    let monday = startOfISOWeek(new Date(year, 0, 1));
    !isAfter(monday, last);
    monday = addWeeks(monday, 1)
  ) {
    const weekStart = format(monday, 'yyyy-MM-dd')
    result.push({
      ...EMPTY,
      ...byStart.get(weekStart),
      weekStart,
      isoWeek: getISOWeek(monday),
    })
  }
  return result
}

export const weekStartDate = (week: YearWeek) => parseISO(week.weekStart)
